<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import RelatorioLoading from './_RelatorioLoading'

  export default {
    components: {RelatorioLoading},
    nome: 'relatorio-leilao-resumo',
    directives: {mask},
    data () {
      return {
        isLoading: false,
        leilao: null
      }
    },
    computed: {
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.isLoading = true
      service.getLeilaoResumo(this.$route.params.id)
        .then((response) => {
          this.isLoading = false
          this.leilao = response.data
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    deactivated () {
    },
    watch: {},
    methods: {
    }
  }
</script>

<template>
  <div class="r-container" :class="{'is-loading': isLoading}">
    <relatorio-loading v-if="isLoading"></relatorio-loading>
    <transition name="slide">
      <div v-if="!isLoading" class="content-transition relatorio-print" id="container-printer">

        <!--<div class="hidden-print">
          <div class="text-center m-t m-b-n">
            <h3 @click="showFiltros = !showFiltros" class="btn m-t-none"><span class="btn btn-default btn-xs m-r-xs">{{ !showFiltros ? '+' : '-' }}</span>Filtros</h3>
          </div>
          <div class="r-table" v-show="showFiltros">
            <div class="r-table-content">
              <div class="m-t">
                <div class="m-b">
                  <div>Tipo de Venda:</div>
                  <u-button-group v-model="filtro.tipo" :options="tiposLeilao"></u-button-group>
                </div>
                <div class="m-b">
                  <div>Situação:</div>
                  <u-button-group :multiSelect="true" v-model="filtro.situacao"
                                  :options="situacaoLote"></u-button-group>
                </div>
                <div class="m-b">
                  Resultados: {{ filteredData && filteredData.length }}
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="hidden-print">
          <h2 class="text-center text-uppercase font-bold m-b-none">Relatório Resumido de Leilão</h2>
          <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
            }}</h4>
        </div>
        <div class="printer-page pos-rlt">
          <div class="visible-print">
            <h2 class="text-center text-uppercase font-bold m-b-none">Relatório Resumido de Leilão</h2>
            <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
              }}</h4>
          </div>
          <div class="r-table">
            <!--<div class="r-table-header">
              <div class="pull-left font-bold text-black">{{ lote.titulo }}</div>
              <div class="pull-right font-bold"><h3 class="m-t-none">Lote {{ lote.numero }}</h3></div>
              <div class="clearfix"></div>
            </div>-->
            <div class="r-table-content">
              <!--<table class="w-full m-b" cellpadding="0" cellspacing="0">
                <tr>
                  <td>Comitente: <strong>{{ lote.comitente.pessoa.nome }}</strong></td>
                  <td class="text-right">Situação: <strong :class="'text-' + Status.Status[lote.status].class">{{
                    Status.Status[lote.status].titulo }}</strong></td>
                </tr>
                <tr>
                  <td>Quantidade de lances: <strong>{{ lote.lances ? lote.lances.length : 0 }}</strong></td>
                  <td class="text-right"><span v-if="lote.arremate">Vencedor: <strong>&lt;!&ndash;{{ lote.arremate.arrematante.pessoa.nome }}&ndash;&gt; {{ lote.arremate.arrematante.apelido }}</strong></span></td>
                </tr>
              </table>-->

              <table class="table table-bordered r-table-min">
                <!--<thead>
                <tr>
                  <th>Quantidade de lotes</th>
                  <th>Apelido</th>
                </tr>
                </thead>-->
                <tbody>
                <tr>
                  <td>Quantidade de lotes</td>
                  <td>{{leilao.lotes.length}}</td>
                </tr>
                <tr>
                  <td>Lotes Retirados</td>
                  <td>{{leilao.stats.lotesRetirados}}</td>
                </tr>
                <tr>
                  <td>Lotes Disponíveis para Leilão</td>
                  <td>{{leilao.stats.lotesDisponiveis}}</td>
                </tr>
                <tr>
                  <td>Vendidos</td>
                  <td>{{leilao.stats.vendidos}} ({{leilao.stats.vendidosPorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td>Não Vendidos</td>
                  <td>{{leilao.stats.naoVendidos}} ({{leilao.stats.naoVendidosPorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td>Lances Online</td>
                  <td>{{leilao.stats.lancesOnline}} ({{leilao.stats.lancesOnlinePorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td>Lances Presencial</td>
                  <td>{{leilao.stats.lancesPresencial}} ({{leilao.stats.lancesPresencialPorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td>Quantidade Total de Lances</td>
                  <td>{{leilao.stats.lancesTotal}}</td>
                </tr>
                <tr>
                  <td>Vendas Online</td>
                  <td>{{leilao.stats.vendasOnline}} ({{leilao.stats.vendasOnlinePorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td>Vendas Presencial</td>
                  <td>{{leilao.stats.vendasPresencial}} ({{leilao.stats.vendasPresencialPorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td>Total Vendido Online</td>
                  <td>R$ {{leilao.stats.totalVendidoOnline|moeda}} ({{leilao.stats.totalVendidoOnlinePorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td>Total Vendido Online com Taxas</td>
                  <td>R$ {{leilao.stats.totalVendidoOnlineComTaxas|moeda}}</td>
                </tr>
                <tr>
                  <td>Total Vendido Presencial</td>
                  <td>R$ {{leilao.stats.totalVendidoPresencial|moeda}} ({{leilao.stats.totalVendidoPresencialPorcentagem|moeda}}%)</td>
                </tr>
                <tr>
                  <td>Total Vendido Presencial com Taxas</td>
                  <td>R$ {{leilao.stats.totalVendidoPresencialComTaxas|moeda}}</td>
                </tr>
                <tr>
                  <td>Total Vendido</td>
                  <td>R$ {{leilao.stats.totalVendido|moeda}}</td>
                </tr>
                <tr>
                  <td>Total Vendido com Taxas</td>
                  <td>R$ {{leilao.stats.totalVendidoComTaxas|moeda}}</td>
                </tr>
                <tr>
                  <td>Comissão do Leiloeiro</td>
                  <td>R$ {{leilao.stats.comissao|moeda}}</td>
                </tr>
                <!--<tr>
                  <td>Total Não Vendido</td>
                  <td>R$ 100.000,00 (80%)</td>
                </tr>-->
                </tbody>
              </table>

            </div>
          </div>
          <!--<div class="p-page-numer visible-print">Página {{key+1}} de {{filteredData && filteredData.length}}</div>-->
        </div>
      </div>
    </transition>
  </div>
</template>



// WEBPACK FOOTER //
// RelatorioResumo.vue?15bab087